import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { ReactNode } from 'react'

interface Props {
  count: number
  /** Bölüm açıkken maddelerin üstünde çizilen kolon başlığı (Görev | Yorum) — aktif listeyle aynı. */
  head?: ReactNode
  children: ReactNode
}

/**
 * "Tamamlananlar" bölümü (113) — açılır/kapanır, Microsoft To Do benzeri.
 *
 * <p><b>Hiç tamamlanmış madde yokken bölüm HİÇ ÇİZİLMEZ.</b> Boş bir "Tamamlananlar (0)" başlığı
 * kullanıcıya olmayan bir içerik vaat eder ve aktif listeyle arasına gereksiz bir ayraç koyardı.
 *
 * <p>Başlangıçta <b>kapalıdır</b>: ekranın işi "ne yapmam gerekiyor" sorusuna cevap vermektir;
 * tamamlananlar geçmiştir ve varsayılan olarak yer kaplamamalıdır. Açık/kapalı durumu bileşenin kendi
 * durumudur — kullanıcı bunu her girişte yeniden seçer; kalıcı bir tercih olarak saklamak, yalnız
 * kozmetik bir ayrıntı için depo anahtarı açmak olurdu.
 */
export default function CompletedSection({ count, head, children }: Readonly<Props>) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  if (count === 0) {
    return null
  }

  return (
    <section className="todo-completed">
      <button
        type="button"
        className="todo-completed-toggle"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <i className={open ? 'pi pi-chevron-down' : 'pi pi-chevron-right'} aria-hidden="true" />
        <span>
          {t('todo.completedSection')} ({count})
        </span>
      </button>
      {open && (
        <>
          {head}
          <ul className="todo-task-list">{children}</ul>
        </>
      )}
    </section>
  )
}
